type ConfirmationRequest = {
  title: string
  description?: string
  detail?: string
  variant?: 'danger' | 'warning' | 'info'
  confirmLabel?: string
  cancelLabel?: string
  input?: { label: string; placeholder?: string; value?: string; required?: boolean; minLength?: number; matchValue?: string; validationMessage?: string }
}

export const DEFAULT_OPERATION_REASON = 'Panel üzerinden açıkça onaylandı'

export function isOperationReasonInput(label?: string): boolean {
  return /(?:neden|reason)/i.test(String(label || ''))
}

export function applyOperationReasonPolicy(options: ConfirmationRequest, required: boolean) {
  if (!options.input || !isOperationReasonInput(options.input.label) || required) {
    return { options, optionalReason: false }
  }
  return {
    optionalReason: true,
    options: {
      ...options,
      input: {
        ...options.input,
        label: `${options.input.label} (isteğe bağlı)`,
        placeholder: 'İsterseniz audit kaydı için kısa bir açıklama yazın',
        required: false,
        minLength: undefined,
      },
    },
  }
}

export function operationReasonValue(value: string | undefined, optional: boolean): string {
  const normalized = String(value || '').trim()
  return normalized.length >= 3 ? normalized : (optional ? DEFAULT_OPERATION_REASON : normalized)
}
